import { useEffect, useState } from 'react';
import { useTemplateParser } from '../api/templating/query';
import { useSendResultToUI } from '../api/user-interface/query';
import { useRenderTemplate } from './use-render-template';

export const useTestTemplate = () => {
  /* Local State */
  const [template, setTemplate] = useState<Record<string, any> | undefined>(
    undefined,
  );
  const [result, setResult] = useState<string | undefined>(undefined);
  const [guard, setGuard] = useState<boolean>(false);
  const [dataGuard, setDataGuard] = useState<boolean>(false);

  /* Hooks */
  const { renderTemplate } = useRenderTemplate();
  /* Queries */
  const sendResult = useSendResultToUI();
  const { data } = useTemplateParser(template);

  /**
   * Effects
   **/
  useEffect(() => {
    if (!data || !guard) return;
    // TODO: type
    setResult(data);
    setDataGuard(true);
  }, [data]);

  useEffect(() => {
    if (!result || !guard || !dataGuard) return;
    sendResult.mutate(result);
    setGuard(false);
    setDataGuard(false);
  }, [result, guard]);

  /**
   * Handlers
   **/
  const handleTestTemplate = async () => {
    const template = renderTemplate();
    setTemplate(template);
    setGuard(true);
  };

  return { handleTestTemplate };
};
